import Vue from 'vue';

// State management
const state = {
  assetsUrl: null,
  roles: [],
  plans: null,
  countries: null,
  euCountries: null,
};

const getters = {
  /**
   * Return the assets url
   */
  getAssetsUrl(state) {
    return state.assetsUrl;
  },

  /**
   * Return the available colors
   */
  getColors(state) {
    return state.colors;
  },

  /**
   * Return the plans object
   */
  getPlans(state) {
    return state.plans;
  },

  /**
   * Return a specific plan limits, taking into account the stripe status.
   * Additionally we calculate the total seats and add them to the limits.
   * @param {string} planPackage
   * @returns {Object} The various limits for this plan
   */
  getPlanLimits(state) {
    return planPackage => {
      return state.plans[planPackage].limits;
    };
  },

  /**
   * Returns countries
   */
  getCountries(state) {
    return state.countries;
  },

  /**
   * Returns eu countries
   */
  getEUCountries(state) {
    return state.euCountries;
  },

  /**
   * Returns the available roles
   */
  getRoles(state) {
    return state.roles;
  },

  /**
   * Returns the available event types
   */
  getEventTypes(state) {
    return state.eventTypes;
  },
};

const actions = {
  /**
   * Set the user pricing plans
   * @param {Array} value The plans
   */
  setPlans(context, { value }) {
    context.commit('setPlans', value);
  },
};

const mutations = {
  /**
   * Set the user pricing plans
   * @param {Array} value The plans
   */
  setPlans(state, value) {
    state.plans = value;
  },
};

const module = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default module;
